import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import absWebService from 'app/services/absWebService';
import reducer from './store';
import { selectNotifications, handleUnreadCountUpdate } from './store/notificationSlice';
import { toggleNotificationPanel } from './store/stateSlice';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';

const wiggleKeyframes = `
@keyframes notif-wiggle {
  0%   { transform: rotate(0deg); }
  15%  { transform: rotate(-18deg); }
  30%  { transform: rotate(16deg); }
  45%  { transform: rotate(-12deg); }
  60%  { transform: rotate(10deg); }
  75%  { transform: rotate(-6deg); }
  90%  { transform: rotate(4deg); }
  100% { transform: rotate(0deg); }
}
`;

function NotificationPanelToggleButton(props) {
  const notifications = useSelector(selectNotifications);
  const { t } = useTranslation('abslayouts');
  const dispatch = useDispatch();

  const hasUnread = notifications.some(n => !n.read);

  const [wiggling, setWiggling] = useState(false);

  // Subscribe to unread count updates piggy-backed on every API response.
  // Fetch notifications only when the count changes.
  useEffect(() => {
    const handleUnreadUpdate = (count) => {
      dispatch(handleUnreadCountUpdate(count));
    };
    absWebService.on('onUnreadNotificationsUpdate', handleUnreadUpdate);
    return () => absWebService.removeListener('onUnreadNotificationsUpdate', handleUnreadUpdate);
  }, [dispatch]);
  const intervalRef = useRef(null);

  function triggerWiggle() {
    setWiggling(true);
    setTimeout(() => setWiggling(false), 700);
  }

  useEffect(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;

    if (hasUnread) {
      // initial wiggle after short delay so icon is visible
      const initial = setTimeout(() => {
        triggerWiggle();
        intervalRef.current = setInterval(triggerWiggle, 5000);
      }, 400);
      return () => {
        clearTimeout(initial);
        clearInterval(intervalRef.current);
      };
    }
  }, [hasUnread]);

  return (
    <>
      <style>{wiggleKeyframes}</style>
      <Tooltip title={t('NOTIFICATIONPANEL_TOOLTIP')} placement="bottom">
        <IconButton
          className="w-40 h-40"
          onClick={(ev) => dispatch(toggleNotificationPanel())}
          size="large"
          style={wiggling ? { animation: 'notif-wiggle 0.7s ease' } : undefined}
        >
          <Badge color="secondary" variant="dot" invisible={!hasUnread}>
            {props.children}
          </Badge>
        </IconButton>
      </Tooltip>
    </>
  );
}

NotificationPanelToggleButton.defaultProps = {
  children: <ABSSvgIcon>heroicons-outline:bell</ABSSvgIcon>,
};

export default withReducer('notificationPanel', reducer)(NotificationPanelToggleButton);
